// Global template helpers used by the faithful views: s() style (RTL-mirrored when Persian),
// hv() hover class (reference `style-hover`), fc() focus class (reference `style-focus`), t() translation.
import type { App } from 'vue';
import { lang, t } from './i18n';
import { rtlStyle } from '@/styles/bidi';
import { pseudoClass } from '@/styles/pseudo';

export const s = (css: string): string => (lang.value === 'fa' ? rtlStyle(css) : css);
export const hv = (css: string): string => pseudoClass('hover', css, lang.value === 'fa');
export const fc = (css: string): string => pseudoClass('focus', css, lang.value === 'fa');

export function installTemplateHelpers(app: App): void {
  app.config.globalProperties.s = s;
  app.config.globalProperties.hv = hv;
  app.config.globalProperties.fc = fc;
  app.config.globalProperties.t = t;
}

declare module 'vue' {
  interface ComponentCustomProperties {
    s: typeof s;
    hv: typeof hv;
    fc: typeof fc;
    t: typeof t;
  }
}
